 import { Header } from "@/components/Header";
 import { Footer } from "@/components/Footer";
 import { SEO } from "@/components/SEO";
 import { Button } from "@/components/ui/button";
 import { Card, CardContent } from "@/components/ui/card";
 import { Zap, Clock, ListTodo, BarChart3, ArrowRight, Brain, Target, Sparkles } from "lucide-react";
 import { Link } from "react-router-dom";
 
 const features = [
   { icon: Clock, title: "포모도로 타이머", description: "과학적인 시간 관리 기법으로 집중력을 극대화하세요." },
   { icon: ListTodo, title: "작업 관리", description: "칸반 보드와 투두 리스트로 작업을 체계적으로 관리하세요." },
   { icon: BarChart3, title: "생산성 분석", description: "일별, 주별 생산성을 추적하고 패턴을 분석하세요." },
   { icon: Brain, title: "집중 모드", description: "방해 요소를 차단하고 깊은 집중 상태를 유지하세요." },
   { icon: Target, title: "목표 설정", description: "일일, 주간 목표를 설정하고 진행 상황을 확인하세요." },
   { icon: Sparkles, title: "AI 지원", description: "AI가 작업을 분석하고 최적의 생산성 팁을 제공합니다." },
 ];
 
 export default function ProductivityToolKr() {
   return (
     <div className="min-h-screen bg-background">
       <SEO 
         title="생산성 도구 | CSW | Online Workspace | Productivity Tool | Study Stream"
         description="무료 생산성 도구로 효율을 높이세요. 포모도로 타이머, 작업 관리, 생산성 분석 기능을 제공합니다."
         keywords="생산성 도구, 생산성 앱, 시간 관리, 작업 관리, 포모도로, 집중력"
         canonicalUrl="/kr/productivity-tool/"
       />
       <Header />
       
       <main>
         <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
           <div className="absolute inset-0 bg-gradient-to-b from-background via-background to-muted" />
           <div className="absolute top-20 left-20 w-96 h-96 bg-primary/20 rounded-full blur-[120px] animate-glow-pulse" />
           
           <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
             <div className="max-w-4xl mx-auto text-center space-y-8">
               <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight">
                 <span className="text-gradient">생산성 도구</span>
               </h1>
               <p className="text-xl sm:text-2xl text-muted-foreground font-light max-w-xl mx-auto">
                 더 적은 시간에 더 많은 것을 달성하세요. 무료 생산성 도구 모음.
               </p>
               <Button size="lg" className="group bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-8 py-6 text-lg" asChild>
                 <a href="https://app.csw.live" target="_blank" rel="noopener noreferrer">
                   지금 시작하기 <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                 </a>
               </Button>
             </div>
           </div>
         </section>
 
         <section className="py-24 px-4 relative overflow-hidden">
           <div className="container mx-auto max-w-6xl">
             <div className="text-center mb-16">
               <h2 className="text-4xl md:text-5xl font-bold font-display mb-6">
                 <span className="text-gradient">생산성</span> 기능
               </h2>
             </div>
             <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
               {features.map((feature) => {
                 const Icon = feature.icon;
                 return (
                   <Card key={feature.title} className="group bg-card/50 backdrop-blur-sm border-border/50 hover:border-primary/50 transition-all hover:scale-105">
                     <CardContent className="p-8 space-y-4">
                       <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary/20 to-secondary/20 flex items-center justify-center">
                         <Icon className="w-6 h-6 text-primary" />
                       </div>
                       <h3 className="text-xl font-semibold text-foreground font-display">{feature.title}</h3>
                       <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
                     </CardContent>
                   </Card>
                 );
               })}
             </div>
           </div>
         </section>
 
         <section className="py-24 px-4 relative overflow-hidden">
           <div className="max-w-4xl mx-auto text-center">
             <h2 className="text-4xl md:text-5xl font-bold mb-6 font-display">
               <span className="text-gradient">생산성</span>을 높이세요
             </h2>
             <Button size="lg" className="group bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-10 py-7 text-lg" asChild>
               <a href="https://app.csw.live" target="_blank" rel="noopener noreferrer">
                 무료로 시작하기 <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
               </a>
             </Button>
           </div>
         </section>
       </main>
       
       <Footer />
     </div>
   );
 }